import DOMPurify from 'dompurify';

/** Tags expected in Contentful rich text and LEP comment bodies. */
export const RICH_TEXT_ALLOWED_TAGS = [
  'a',
  'b',
  'blockquote',
  'br',
  'div',
  'em',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'hr',
  'i',
  'li',
  'ol',
  'p',
  'span',
  'strong',
  'u',
  'ul',
] as const;

export const RICH_TEXT_ALLOWED_ATTR = ['class', 'href', 'id', 'rel', 'target'] as const;

/** Sanitizes trusted CMS HTML before it is injected via dangerouslySetInnerHTML. */
export const sanitizeRichTextHtml = (html: string): string =>
  DOMPurify.sanitize(html, {
    ALLOWED_TAGS: [...RICH_TEXT_ALLOWED_TAGS],
    ALLOWED_ATTR: [...RICH_TEXT_ALLOWED_ATTR],
    ALLOW_DATA_ATTR: false,
  });

/** Sanitizes Contentful entry body HTML for Educate, FAQ, and emergency pages. */
export const prepareContentfulHtml = (html: string): string => sanitizeRichTextHtml(html ?? '');
